(function($, undefined) {
	
	'use strict';
	var utils;
	var form;
	var header;
	var popup;
	
	var delAudition = function () {
		var lang = $('html').attr('lang');
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var item = $('.audition-list-item[data-id="'+itemId+'"]');
		var tpopup = t.closest('.popup');
		var message = $('textarea[name=audition-single-delete-text]').val();
		var subject = $('input[name=audition-single-delete-subject]').val();
		var auditionName = $('.audition-single-main-title').html();
		var list = $('.audition-single-audition-invitees-emails').val();

		tpopup.addClass('is-processing');

		var _complete = function() {
			$.ajax({
				url: '/action/vcSendAuditionInvitations',
				cache: false,
				data: {
					auditionId: itemId,
					delete: true,
					ajax: true
				},
				method: 'POST',
				success: function (response) {
					var isSuccess = $.trim(response) === 'success';
					// console.log('project : ' + response + ', ' + isSuccess);
					
					if (isSuccess) {
						form.showErrorPopupAnimation('audition-delete-success');
						
						if (item.length) {
							item.slideUp(200, function () {
								item.remove();
							});
                            popup.closeAllPopup();
						} else {
							window.location.href = t.attr('data-redirect');
						}
					} else {
						form.showErrorPopupAnimation('audition-delete-error');
					}
				}
			});
		};

		if (tpopup.find('input[name=toggle-audition-deleted-msg-checkbox]').is(':checked')) {
			var emailsArray = list.split(',');
			var count = 0;
			var total = emailsArray.length;

			emailsArray.forEach(function(emailAddr) {
				count++;
				
				utils.sendEmail(emailAddr, subject, message, 'audition-delete-' + lang, {field1: auditionName}, function(response) {
					// console.log('sending email : ' + response);

					if (count >= total) {
						_complete();
					}
				});
			});
		} else {
			_complete();
		}
	};
	
	var duplicateAudition = function () {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var item = $('.audition-box[data-id="'+itemId+'"], .audition-single-data');
		var redirect = t.attr('data-redirect');
		var currDate = new Date();
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				field1: item.attr('data-field1'),
				field2: item.attr('data-field2'),
				field3: item.attr('data-field3'),
				field4: item.attr('data-field4'),
				field5: item.attr('data-field5'),
				field6: item.attr('data-field6'),
				field8: item.attr('data-field8'),
				field9: item.attr('data-field9'),
				field10: item.attr('data-field10'),
				field11: item.attr('data-field11'),
				field12: item.attr('data-field12'),
				field13: '0',
				field14: item.attr('data-field14'),
				field15: item.attr('data-field15'),
				field16: item.attr('data-field16'),
				field17: item.attr('data-field17'),
				field18: item.attr('data-field18'),
				field19: item.attr('data-field19'),
				dateField1Year: currDate.getFullYear(),
				dateField1Month: currDate.getMonth(),
				dateField1Day: currDate.getDate(),
				dateField1Hour: currDate.getHours(),
				dateField1Minute: currDate.getMinutes(),
				dateField1Second: currDate.getSeconds(),
				dateField2Year: item.attr('data-date2Year'),
				dateField2Month: item.attr('data-date2Month'),
				dateField2Day: item.attr('data-date2Day'),
				dateField2Hour: 0,
				dateField2Minute: 0,
				dateField2Second: 0,
				dateField3Year: item.attr('data-date3Year'),
				dateField3Month: item.attr('data-date3Month'),
				dateField3Day: item.attr('data-date3Day'),
				dateField3Hour: 0,
				dateField3Minute: 0,
				dateField3Second: 0,
				friendlyUrlField: 'field3',
				redirectToFriendlyUrl: true,
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				console.log('Auditions form : ' + response);
				var newId = response.substring('success-'.length);
				
				window.location.href = redirect + '/' + newId;
			}
		});
	};
	
	var publishAudition = function () {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var popup = t.closest('.popup');
		
		popup.addClass('is-processing');
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				field13: '1',
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition publish : ' + response + ', ' + isSuccess);
				
				if (isSuccess) {
					form.showErrorPopupAnimation('audition-publish-success');
					
					var notifier = document.querySelector('.audition-list-item-publish-notification-'+itemId);
					if (notifier) {
						$.ajax({
							url: '/action/vcCreateNotification',
							data: {
								newPublicAudition: true,
								label: 'notification-audition-public-published',
								values: notifier.getAttribute('data-name') + ',' + notifier.getAttribute('data-url'),
								auditionId: itemId
							},
							cache: false,
							success: function() {
								window.location.reload();
							}
						});
					} else {
						window.location.reload();
					}
				} else {
                    popup.removeClass('is-processing');
					form.showErrorPopupAnimation('audition-publish-error');
				}
			}
		});
	};
	
	var draftAudition = function () {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				field13: '0',
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition sketch : ' + response + ', ' + isSuccess);
				
				if(isSuccess) {
					form.showErrorPopupAnimation('audition-sketch-success');
					
					window.location.reload();
				} else {
					form.showErrorPopupAnimation('audition-sketch-error');
				}
			}
		});
	};
	
	var closeAudition = function () {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var itemData = $('.audition-list-item-close-notification-'+itemId).data();
		var personId = itemData.person;
		var auditionName = itemData.name;
		var list = itemData.invitees;
		var notify = $('.notify-invitees-audition-closed-checkbox').prop('checked');
		var extraData = $('.audition-single-data').attr('data-extra').length !== 0 ? JSON.parse($('.audition-single-data').attr('data-extra')) : {};
		
		extraData['manualClose'] = true;
		
		if (personId === '') {
			personId = $('.audition-single-person-id').val();
		}
		if (auditionName === '') {
			auditionName = $('.audition-single-main-title').text();
		}
		if (list === '') {
			list = $('.audition-single-audition-invitees').val();
		}
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				extraData: JSON.stringify(extraData),
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition close : ' + response + ', ' + isSuccess);
				
				if(isSuccess) {
					form.showErrorPopupAnimation('audition-close-success');
					// Audition closed
					console.log(list, auditionName, personId);
					if (list !== '' && notify) {
						Fw.component.models().notificationUtils.sendNotificationPerson(
							list,
							"AUDITION_CLOSED",
							auditionName,
							function () {
								window.location.reload();
							}, 
							{ field8: personId }
						);
					} else {						
						window.location.reload();
					}
				} else {
					form.showErrorPopupAnimation('audition-close-error');
				}
			}
		});
	};
	
	var uncloseAudition = function () {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var extraData = $('.audition-single-data').attr('data-extra').length !== 0 ? JSON.parse($('.audition-single-data').attr('data-extra')) : {};
		
		extraData['manualClose'] = false;
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				extraData: JSON.stringify(extraData),
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition unclose : ' + response + ', ' + isSuccess);
				
				if(isSuccess) {
					form.showErrorPopupAnimation('audition-unclose-success');
					
					window.location.reload();
				} else {
					form.showErrorPopupAnimation('audition-unclose-error');
				}
			}
		});
	};
	
	var archiveAudition = function () {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				field13: '4',
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition archive : ' + response + ', ' + isSuccess);
				
				if(isSuccess) {
					form.showErrorPopupAnimation('audition-archive-success');
					
					window.location.reload();
				} else {
					form.showErrorPopupAnimation('audition-archive-error');
				}
			}
		});
	};
    
    var showList = function(e) {
        var btn = e.currentTarget;
        var hash = btn.href.substr(btn.href.indexOf('#') + 1);
        
        $('.auditions-list-anchors-ctn .btn.selected').removeClass('selected');
        $('.auditions-list-wrap.selected').removeClass('selected');
        
        $(btn).addClass('selected');
        $('.auditions-list-wrap[data-anchor="' + hash + '"]').addClass('selected');
    };
	
	var checkEmptyList = function() {
        var $it = $(this);
        var itemCount = $it.find('.audition-box').length;
        var emptyMsger = $it.prev('.auditions-list-empty');
        
		if (itemCount) {
			emptyMsger.hide();
            if (!$it.closest('.auditions-com-slider-ctn')[0]) {
                emptyMsger.before('<p>' + itemCount + ' auditions</div>');
            }
		} else {
			emptyMsger.show();
			if ($it.closest('.public-auditions-com').length !== 0) {
				$it.closest('.public-auditions-com').slideUp(0);
			}
		}
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		form = Fw.component.models().form;
		header = Fw.modules.models().header;
		popup = Fw.component.models().popup;
		
		$('body').on('click', '.js-audition-list-item-del', delAudition);
		$('body').on('click', '.js-audition-list-item-duplicate', duplicateAudition);
		$('body').on('click', '.js-audition-list-item-publish', publishAudition);
		$('body').on('click', '.js-audition-list-item-sketch', draftAudition);
		$('body').on('click', '.js-audition-list-item-close', closeAudition);
		$('body').on('click', '.js-audition-list-item-unclose', uncloseAudition);
		$('body').on('click', '.js-audition-list-item-archive', archiveAudition);
		
//        $('.auditions-list-anchors-ctn .btn').on('click', showList);
//        if (!window.location.hash) {
//            // Show the first content list
//            $('.auditions-list-anchors-ctn .btn:eq(0)').trigger('click');
//        } else {
//            $('.auditions-list-anchors-ctn .btn[href*="' + window.location.hash + '"]').trigger('click');
//        }
		$('.auditions-list').each(checkEmptyList);
        $('.auditions-list-ctn .processing-loader').removeClass('is-processing');
	};
	
	$(window).ready(init);
	
})(jQuery);
